/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { takeWhile, map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'prof-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class CallbackComponent implements OnInit {
  profile;

  constructor(private _auth: AuthService, private route: ActivatedRoute) {}

  ngOnInit() {
    this._auth.setOnboarding(false);

    // The access_token fragment means we are at the end of onboarding
    this.route.fragment
      .pipe(
        map((fragment) => new URLSearchParams(fragment)),
        map((params) => ({
          access_token: params.get('access_token'),
          id_token: params.get('id_token'),
          error: params.get('error'),
        }))
      )
      .subscribe((res) => {
        if (res.access_token) {
          this._auth.loginRedirect();
        }
      });

    this._auth.user$
      .pipe(takeWhile(() => this.profile === null))
      .subscribe((p) => {
        this.profile = p;
        this._auth.loginRedirect();
      });
  }
}
